import Marquee from 'react-fast-marquee';

const WORDS = [
  'Aesthetics',
  'Interaction',
  'Strategy',
  'Digital Design',
  'Motion',
  'Systems',
];

export default function EditorialMarquee() {
  return (
    <section className="relative border-y border-border py-10 md:py-16">
      <Marquee speed={55} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="text-stroke px-8 font-display text-6xl font-extrabold uppercase tracking-tight md:text-8xl">
              {w}
            </span>
            <span className="text-2xl text-muted-foreground md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
